<div class="topbar">
  <div>
    <h1>Indstillinger for Modeller</h1>
  </div>
  <div class="topbar__actions">
    <app-model-list-filter
      [fabrikater]="filteredFabrikater"
      [produkter]="produkter"
      [filter]="filter"
      class="filter flex"
    ></app-model-list-filter>
    @if (canEdit) {
      <button class="btn-icon green" (click)="add()" matTooltip="Opret model">
        <mat-icon svgIcon="add"></mat-icon>
        <span>Opret model</span>
      </button>
    }
  </div>
</div>
<div class="page__content settings">
  <div class="settings__wrap">
    <table mat-table [dataSource]="modeller" class="mat-elevation-z0 settings__table">
      <ng-container matColumnDef="fabrikat">
        <th mat-header-cell *matHeaderCellDef>Fabrikat</th>
        <td mat-cell *matCellDef="let row">
          {{ row.fabrikat?.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="produkt">
        <th mat-header-cell *matHeaderCellDef>Produkt</th>
        <td mat-cell *matCellDef="let row">
          {{ row.fabrikat?.produkt?.text }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Navn</th>
        <td mat-cell *matCellDef="let row">
          {{ row.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="modelstatus">
        <th mat-header-cell *matHeaderCellDef>Tillad oprettelse</th>
        <td mat-cell *matCellDef="let row">
          {{ modelstatus(row.modelstatus) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell class="row-actions" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <div class="hidden-cell">
            @if (canEdit) {
              <button (click)="edit(row)" class="btn-icon blue" aria-label="Rediger model" matTooltip="Rediger model">
                <mat-icon svgIcon="edit"></mat-icon>
              </button>
            }
            <button (click)="showhistory(row)" class="btn-icon blue" aria-label="Historik" matTooltip="Historik">
              <mat-icon>timeline</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
<app-history-view [historyView]="historyView"></app-history-view>
